<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0"> {{ title }}</span>
      </v-card-title>
      <v-card-actions>
        <!-- <v-btn v-if="!cantEdit" @click="save()">保存</v-btn> -->
        <v-btn v-if="!cantEdit" @click="tempSave()">保存</v-btn>
        <v-btn @click="goToList()">{{ $t("app.buttons.back") }}</v-btn>
        <v-btn v-if="bl.id" @click="printPdf()">袋印刷</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">運送情報</span>
      </v-card-title>
      <v-form ref="form" lazy-validation v-model="valid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-select
                :disabled="bl.id || cantEdit"
                required
                :items="[
                  { text: '仲介出', value: '仲介出' },
                  { text: '日本出', value: '日本出' },
                ]"
                :rules="rulesSwitch(placerWayRules)"
                clearable
                item-text="text"
                item-value="value"
                label="仲介/日本出し"
                v-model="bl.placerWay"
              ></v-select
            ></v-flex>
            <v-flex md3 sm6 xs12
              ><v-select
                :disabled="cantEdit"
                required
                :items="$store.state.shippingModes"
                clearable
                item-text="text"
                item-value="value"
                label="輸送区分"
                :rules="rulesSwitch(shippingModeRules)"
                v-model="bl.shippingMode"
              ></v-select>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="bl.id || cantEdit"
                required
                label="B/L No"
                clearable
                :rules="blNoRules"
                v-model="bl.blNo"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <date-input
                :disabled="cantEdit"
                clearable
                required
                label="B/L DATE"
                :rules="blDateRules"
                v-model="bl.blDate"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><remote-autocomplete
                :disabled="cantEdit"
                label="生産拠点"
                url="expense-codes/code/kv"
                v-model="bl.shipperCode"
            /></v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="cantEdit"
                label="バイヤー"
                url="buyers/code/kv"
                :rules="rulesSwitch(consigneeCodeRules)"
                v-model="bl.consigneeCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12
              ><remote-autocomplete
                :disabled="cantEdit"
                label="積出港"
                url="ports/kv?tradeType=EXPORT"
                :rules="rulesSwitch(originPortCodeRules)"
                v-model="bl.originPortCode"
            /></v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="cantEdit"
                label="仕向港"
                url="ports/kv?tradeType=EXPORT"
                :rules="rulesSwitch(dischargePortCodeRules)"
                v-model="bl.dischargePortCode"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><remote-autocomplete
                @change="changeOrderPlacer"
                :disabled="bl.id || cantEdit"
                label="船積担当者"
                url="employees/tdoc-kv"
                :rules="rulesSwitch(orderPlacerCodeRules)"
                v-model="bl.orderPlacerCode"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><remote-autocomplete
                disabled
                label="代理受付者"
                url="employees/tdoc-kv"
                v-model="bl.proxyPlacerCode"
            /></v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="cantEdit"
                label="乙仲担当者"
                url="employees/tdoc-kv"
                v-model="bl.carrierCode"
            /></v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                disabled
                label="代理更新者"
                url="employees/tdoc-kv"
                v-model="bl.proxyUpdaterCode"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><v-text-field
                :rules="[
                  (v) =>
                    !v ||
                    (!!v && v.length <= 25) ||
                    '本船名/FLT Noを25文字以下にしてください',
                ]"
                :disabled="cantEdit"
                label="本船名/FLT No"
                clearable
                v-model="bl.shipsName"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><date-input :disabled="cantEdit" label="ETA" v-model="bl.eta"
            /></v-flex>
            <v-flex md3 sm6 xs12
              ><div class="lc-ref-no">
                <v-text-field
                  :disabled="cantEdit"
                  required
                  label="L/C Ref No"
                  :rules="rulesSwitch(refNoRules)"
                  clearable
                  v-model="bl.refNo"
                />
                <span class="lc-ref-no-split"> - </span>
                <v-text-field
                  :disabled="cantEdit"
                  required
                  label="枝番"
                  :rules="rulesSwitch(lcRefSerialNoRules)"
                  clearable
                  v-model="bl.lcRefSerialNo"
                /></div
            ></v-flex>
            <v-flex xs12>
              <v-textarea
                :rules="[
                  (v) =>
                    !v ||
                    (!!v && v.length <= 200) ||
                    '備考を200文字以下にしてください',
                ]"
                :disabled="cantEdit"
                label="備考"
                v-model="bl.remark"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">仕入INV No 情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn v-if="!cantEdit" @click="addBuyerInvoice">追加</v-btn>
      </v-card-actions>
      <v-card-text>
        <div class="card-content">
          <v-chip
            @input="close(item)"
            v-for="item in bl.buyerInvNo"
            :key="item"
            class="ma-2"
            :close="!cantEdit"
            color="orange"
            outline
          >
            <span class="over-content" :title="item">{{ item }}</span>
          </v-chip>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mt-2" style="width: 100%; display: flex">
      <invoice-info
        :cantEdit="cantEdit"
        :isJp="isJp"
        @refreshInvAttachmentDate="refreshInvAttachmentDate"
        style="width: 60%"
        :bl="bl"
        ref="invoiceInfo"
      />
    </v-card>
    <v-card class="mt-2">
      <bl-pdf-info :cantEdit="cantEdit" :bl="bl" ref="blPdfInfo" />
    </v-card>
    <v-card v-if="!isWebViewer" class="mt-2">
      <schedule-info
        :cantEdit="cantEdit"
        :bl="bl"
        ref="scheduleInfo"
      ></schedule-info>
    </v-card>

    <add-buyer-invoice-dialog
      :bl="bl"
      @appendBuyerInvNo="appendBuyerInvNo"
      ref="addBuyerInvoiceDialog"
    />
  </v-container>
</template>

<script>
import InvoiceInfo from "./InvoiceInfo.vue";
import BlPdfInfo from "./BlPdfInfo.vue";
import ScheduleInfo from "./ScheduleInfo.vue";
import addBuyerInvoiceDialog from "./AddBuyerInvoiceDialog.vue";

export default {
  components: {
    InvoiceInfo,
    BlPdfInfo,
    ScheduleInfo,
    addBuyerInvoiceDialog,
  },
  data() {
    return {
      placerWayRules: [
        (v) =>
          !!v || "仲介/日本出し" + this.$t("app.validator.messages.required"),
      ],
      shipperCodeRules: [
        (v) => !!v || "生産拠点" + this.$t("app.validator.messages.required"),
      ],
      orderPlacerCodeRules: [
        (v) => !!v || "船積担当者" + this.$t("app.validator.messages.required"),
      ],
      shippingModeRules: [
        (v) => !!v || "輸送区分" + this.$t("app.validator.messages.required"),
      ],
      consigneeCodeRules: [
        (v) => !!v || "バイヤー" + this.$t("app.validator.messages.required"),
      ],
      blNoRules: [
        (v) => !!v || "B/L No" + this.$t("app.validator.messages.required"),
        (v) => (!!v && v.length <= 50) || "B/L Noを50文字以下にしてください",
      ],
      originPortCodeRules: [
        (v) => !!v || "積出港" + this.$t("app.validator.messages.required"),
      ],
      refNoRules: [
        (v) =>
          !v ||
          (!!v && v.length <= 20) ||
          "L/C Ref Noを20文字以下にしてください",
      ],
      lcRefSerialNoRules: [
        (v) => !v || (!!v && v.length <= 5) || "枝番を5文字以下にしてください",
      ],
      blDateRules: [
        (v) => !!v || "B/L DATE" + this.$t("app.validator.messages.required"),
      ],
      dischargePortCodeRules: [
        (v) => !!v || "仕向港" + this.$t("app.validator.messages.required"),
      ],
      chip1: true,
      chip2: true,
      valid: false,
      bl: {
        invoices: [],
        buyerInvNo: [],
        attachments: [],
        placerWay: "仲介出",
        // siReleaseDate: this.$today(),
      },
      selected: [],
      required: null,
      currentItem: null,
    };
  },
  methods: {
    appendBuyerInvNo(buyerInvNos) {
      this.bl.buyerInvNo = [...this.bl.buyerInvNo, ...buyerInvNos];
    },
    printPdf() {
      return this.$download(`/tdoc/bls/${this.bl.id}/pdf`);
    },
    rulesSwitch(validation) {
      if (this.required === "temporary") {
        return [];
      } else {
        return validation;
      }
    },
    setRequiredAndNextTick(value, func) {
      this.required = value;
      this.$nextTick(func);
    },
    goToList() {
      this.$router.push("/t-doc");
    },
    addBuyerInvoice() {
      this.$refs.addBuyerInvoiceDialog.popup().then((invoice) => {
        if (!this.bl.buyerInvNo) {
          this.bl.buyerInvNo = [];
        }
        if (this.bl.buyerInvNo.indexOf(invoice) !== -1) {
          this.$message("", "仕入INV NO重複で登録できません。");
          return;
        }
        this.bl.buyerInvNo.push(invoice);
        this.$forceUpdate();
      });
    },
    close(item) {
      const index = this.bl.buyerInvNo.indexOf(item);
      if (index > -1) {
        this.bl.buyerInvNo.splice(index, 1);
      }
    },
    validData() {
      if (!this.isJp && this.bl.buyerInvNo.length === 0) {
        this.$message(
          "",
          "種類が【仲介出】になる場合、仕入INV NOが必須になります。"
        );
        return false;
      }
      if (
        !this.bl.invoices ||
        this.bl.invoices.length === 0 ||
        this.bl.invoices.filter((inv) => !!inv.invNo).length !==
          this.bl.invoices.length
      ) {
        this.$message("", "InvoiceNoが必須になります。");
        return false;
      }
      // if (this.isJp && this.bl.invoices.filter((i) => !i.edNo).length > 0) {
      //   this.$message('', '種類が【日本出】になる場合、edNoが必須になります。')
      //   return false
      // }

      if (!this.isJp && this.bl.invoices.filter((i) => !i.siNo).length > 0) {
        this.$message("", "種類が【仲介出】になる場合、siNoが必須になります。");
        return false;
      }

      return true;
    },
    save() {
      this.setRequiredAndNextTick("formal", () => {
        if (!this.validateData()) return;
        if (!this.validData()) return;
        this.$http
          .post("/tdoc/bls/create", {
            ...this.bl,
            status: "CONFIRMED",
          })
          .then((res) => {
            this.$router.push({
              name: "TdocEdit",
              query: {
                id: res.data.replace("A", ""),
                title: "B/L 編集",
              },
            });
            this.$message("", "BL登録しました。");
          })
          .catch((err) => {
            if (this.$te(`tdoc.${err.response.data}`)) {
              this.$message("", this.$t(`tdoc.${err.response.data}`));
            } else {
              this.$message("", this.$t("app.system.error"));
            }
          });
      });
    },
    tempSave() {
      this.setRequiredAndNextTick("temporary", () => {
        if (!this.validateData()) return;
        if (!this.validTempData()) return;
        this.$http
          .post("/tdoc/bls/create", {
            ...this.bl,
            status: "DRAFT",
          })
          .then((res) => {
            this.$router.push({
              name: "TdocEdit",
              query: {
                id: res.data.replace("A", ""),
                title: "B/L 編集",
              },
            });
            // this.goToList()
            this.$message("", "保存しました。");
          })
          .catch((err) => {
            if (this.$te(`tdoc.${err.response.data}`)) {
              this.$message("", this.$t(`tdoc.${err.response.data}`));
            } else {
              this.$message("", this.$t("app.system.error"));
            }
          });
      });
    },
    validateData() {
      if (!this.$refs.form.validate()) return false;
      if (!this.bl.blNo) {
        this.$message("", "B/L Noは必須です。");
        return false;
      }
      if (!this.bl.blDate) {
        this.$message("", "B/L DATEは必須です。");
        return false;
      }
      if (
        this.$refs.scheduleInfo &&
        !this.$refs.scheduleInfo.$refs.form.validate()
      ) {
        this.$message("", "進捗情報に不備があり、ご確認ください。");
        return false;
      }
      return true;
    },
    validTempData() {
      if (
        !this.bl.invoices ||
        this.bl.invoices.length === 0 ||
        this.bl.invoices.filter((i) => !!i.siNo).length < 1
      ) {
        this.$message("", "SI Noが必須になります。");
        return false;
      }
      return true;
    },
    refreshInvAttachmentDate() {
      this.bl.invAttachmentUpdateDate = this.$today();
    },
    initPlacer() {
      if (!this.bl.orderPlacerCode) {
        this.bl.orderPlacerCode = this.$getEmployee().username;
      }
      // if (!this.bl.proxyPlacerCode && (this.bl.orderPlacerCode !== this.$getEmployee().code)) {
      //   this.bl.proxyPlacerCode = this.$getEmployee().code
      // }
      if (this.bl.id) {
        if (
          (!this.bl.proxyPlacerCode &&
            this.bl.orderPlacerCode !== this.$getEmployee().username) ||
          (this.bl.orderPlacerCode !== this.$getEmployee().username &&
            this.bl.proxyPlacerCode !== this.$getEmployee().username)
        ) {
          this.bl.proxyUpdaterCode = this.$getEmployee().username;
        }
      }
      this.$forceUpdate();
    },
    changeOrderPlacer() {
      if (!this.$route.query.disabled) {
        if (this.bl.orderPlacerCode !== this.$getEmployee().username) {
          this.bl.proxyPlacerCode = this.$getEmployee().username;
        } else {
          this.bl.proxyPlacerCode = undefined;
        }
        this.$forceUpdate();
      }
    },
    load() {
      // new load nothing
    },
    showFullWords(words) {
      this.currentItem = words;
    },
    removeItem() {
      this.currentItem = null;
    },
  },
  mounted() {
    if (!!this.$route.query.disabled && this.$route.query.eventId) {
      this.$http
        .get(`/tdoc/bls/events/${this.$route.query.eventId}`)
        .then((res) => {
          this.bl = res.data;
        });
    }
    if (!this.$route.query.disabled) {
      this.initPlacer();
    }
  },
  computed: {
    hasCovered() {
      return true === this.bl.covered;
    },
    isJp() {
      return "日本出" === this.bl.placerWay;
    },
    cantEdit() {
      return !!Boolean(this.$route.query.disabled);
    },
    title() {
      return !!this.$route.query.title
        ? this.$route.query.title
        : this.$route.query.disabled
        ? "B/L詳細"
        : "B/L登録";
    },
    isWebViewer() {
      return this.$getEmployee().roles.indexOf("ROLE_WEB_VIEWER") > -1;
    },
  },
};
</script>

<style scoped>
.lc-ref-no {
  display: flex;
}

.lc-ref-no-split {
  padding: 5px;
  padding-top: 20px;
}

.card-content {
  padding: 5px 15px;
  background: #f0f0f0;
}
</style>
